import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { delay, Observable } from "rxjs";

export class UsersRest {
  getUsers(params: QueryParams): Observable<any> {
    const url: string = `/user`;
    return api.get(url, params);
  }

  getUserById(userId: string): Observable<any> {
    const url: string = `/user/${userId}`;
    return api.get(url);
  }

  postUser(data: any): Observable<any> {
    const url: string = `/user`;
    return api.post(url, data).pipe(delay(1000));
  }

  putUser(userId: string, data: any): Observable<any> {
    const url: string = `/user/${userId}`;
    return api.put(url, data).pipe(delay(1000));
  }

  postUserStudent(data: any): Observable<any> {
    const url: string = `/course-student`;
    return api.post(url, data).pipe(delay(1000));
  }

  putUserStudent(userId: string, data: any): Observable<any> {
    const url: string = `/course-student/${userId}`;
    return api.put(url, data).pipe(delay(1000));
  }

  importUsers(data: any): Observable<any> {
    const url: string = `/user/import`;
    return api.post(url, data);
  }

  importUsersByCourse(courseId: string, data: any): Observable<any> {
    const url: string = `/course-student/import/${courseId}`;
    return api.post(url, data);
  }

  getUserStudentById(userId: string): Observable<any> {
    const url: string = `/course-student/${userId}`;
    return api.get(url);
  }

  getProfileUser(): Observable<any> {
    const url: string = `/user/details`;
    return api.get(url);
  }

  getAllAvatars(params?: QueryParams): Observable<any> {
    const url: string = `/avatar`;
    return api.get(url, params);
  }

  updateProfileUser(data: any): Observable<any> {
    const url: string = `/user/details/profile`;
    return api.put(url, data);
  }

  postPhotoProfile(data: any): Observable<any> {
    const url: string = `/user/details/photo-profile`;
    return api.post(url, data);
  }

  updatePassword(data: any): Observable<any> {
    const url: string = `/user/details/change-password`;
    return api.post(url, data);
  }

  getUserResultsHistory(
    userId: string,
    courseId: string,
    params?: Partial<QueryParams>
  ): Observable<any> {
    const url: string = `/users/${userId}/courses/${courseId}/performances`;
    return api.get(url, params);
  }

  updateUserConfigurations(data: any): Observable<any> {
    const url: string = `/user/details/configurations`;
    return api.put(url, data);
  }

  getUserConfigurations(): Observable<any> {
    const url: string = `/user/details/configurations`;
    return api.get(url);
  }

  updateTeacherProfile(userId: string, data: any): Observable<any> {
    const url: string = `/user/${userId}`;
    return api.patch(url, data).pipe(delay(1000));
  }
}
